import React, {Fragment, useContext, useState, useEffect } from 'react';
import { Redirect, useLocation, useHistory } from "react-router-dom";
import GullLayout from "app/GullLayout/GullLayout";
import { IsAuthContext } from "../App";
import { PeripheriqueContext } from '../App';
import { Loading } from "@gull";
import axios from 'axios'
import { useTranslate } from 'react-redux-multilingual'
import swal from "sweetalert2";
import useRhInventoryCookie from './useRhInventoryCookie';

export const WmsSectionAuthContext = React.createContext()

const Guard = (props) => {
    const t =useTranslate()
    const location = useLocation();
    const history = useHistory()
    const domain = location.pathname.split('/');
    const globalUserParam = useContext(IsAuthContext);
    const globalPeripheriqueParam = useContext(PeripheriqueContext)
    const rhInventoryCookie = useRhInventoryCookie()

    //Le contrôle "staff bien affecté à ce commerce" ne s'applique que si l'authentification WMS est requise pour ce commerce.
    //Si elle ne l'est pas, l'accès au module reste libre (seuls les écrans qui exigent leur propre badge, ex: inventaire, transferts, restent protégés indépendamment)
    const wmsSection = (domain[1]=='wms' && Array.isArray(globalUserParam.authParam.sections)) ? globalUserParam.authParam.sections.find(value=>value.id==domain[2]) : false
    const wmsAuthRequired = !!(wmsSection && wmsSection.advanceparams && wmsSection.advanceparams.wms_auth_required)
    //Vérifie que le staff identifié (badge WMS) est bien affecté au commerce visité, la session étant globale à tous les commerces WMS
    const [rhSectionCheck,setRhSectionCheck] = useState({sectionId:false,status:'na'})

    useEffect(function () {
        if(domain[1]=='wms' && wmsAuthRequired && rhInventoryCookie){
            const rhId = rhInventoryCookie.split(',')[0]
            axios.get(process.env.REACT_APP_API_URL+"api/rh/is_in_section/"+domain[2]+"/"+rhId
            ).then((response) => {
                setRhSectionCheck({sectionId:domain[2],status:response.data.valid ? 'authorized' : 'unauthorized'})
            }).catch((error) => {
                if(error=='end_session') return;
                setRhSectionCheck({sectionId:domain[2],status:'unauthorized'})
            })
        }else{
            setRhSectionCheck({sectionId:false,status:'na'})
        }
    }, [domain[1],domain[2],wmsAuthRequired,rhInventoryCookie])

    //tant que la vérification ne concerne pas explicitement le commerce actuellement visité, on considère qu'elle est en cours
    const rhSectionStatus = (rhSectionCheck.sectionId===domain[2]) ? rhSectionCheck.status : 'checking'

    const verifPeripherique = async (posId,caisse_ident) => {
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/pos/pos/get_one_caisse_ident/"+caisse_ident
        ).then((response) => {
            if(!response.data.valid){
                swal.fire(t('unknowError'), "", "error");
            }
            else{
                let all_peripherique = { // liste des peripherique par type. S'il y a de nouveaux types de peripherique alors il faut les ajouter ici
                    section:posId,
                    caisse_ident:caisse_ident,
                    afficheur: false,
                    imprimante_ticket: false,
                    imprimante_ticket_preparation: false,
                    imprimante_etiquette: false,
                    tpe:false
                }
                response.data.data.peripherique.forEach(value=>{
                    all_peripherique[value.type]={
                        name:value.name,
                        host:value.host,
                        model:value.model,
                        hostname:value.hostname,
                        baudrate:value.baudrate,
                    }
                })
                globalPeripheriqueParam.setPeripheriqueParam(all_peripherique)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
    }

    const verifyCaisseOpen = async (posId,caisseid,caisse_ident) =>{
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/pos/pos/pos_status/"+posId+'/'+caisseid+'/'+caisse_ident
        ).then((response) => {
            if(!response.data.valid){
                localStorage.removeItem('pos')
                history.push("/openpos/"+domain[2])
            }
            else{
                let valid=true
                if(!globalPeripheriqueParam.peripheriqueParam) valid=false// on verifie qu'il connaisse ses peripherique, si ce n'est pas le cas alors on lui dit d'aller les chercher dans la fonction ci-dessous
                else if(globalPeripheriqueParam.peripheriqueParam.caisse_ident!=caisse_ident) valid=false//ou alors on verifie s'il n'a pas les perihperique d'une autre caisse en memoire
                    
                if(!valid) verifPeripherique(posId,caisse_ident)
            }
        }).catch((error) => {
            localStorage.removeItem('pos')
            history.push("/openpos/"+domain[2])
            // if(error=='end_session') return;
            // swal.fire(t('unknowError'), "", "error");
        })
    }

    if(globalUserParam.authParam.isauth==='wait'){
        return(<Loading></Loading>)
    }
    else if(!globalUserParam.authParam.isauth){
        return <Redirect to="/session/signin" />
    }
    else if(domain[1]=='pos'){
        const open=localStorage.getItem("pos")
        if(open){
            const ids = open.split(',');
            const caisseid = ids[0]
            const caisse_ident = ids[1]
            
            verifyCaisseOpen(domain[2],caisseid,caisse_ident)
        }
        else{
            return <Redirect to={"/openpos/"+domain[2]} />
        }
    }
    else if(domain[1]=='cloturepos'){
        const open=localStorage.getItem("pos")
        if(open){
            const ids = open.split(',');
            const posId = ids[0]
            const caisse_ident = ids[1]
            let valid=true
            if(!globalPeripheriqueParam.peripheriqueParam) valid=false// on verifie qu'il connaisse ses peripherique, si ce n'est pas le cas alors on lui dit d'aller les chercher dans la fonction ci-dessous
            else if(globalPeripheriqueParam.peripheriqueParam.caisse_ident!=caisse_ident) valid=false//ou alors on verifie s'il n'a pas les perihperique d'une autre caisse en memoire
            if(!valid) verifPeripherique(posId,caisse_ident)
        }
    }
    else if(domain[1]=='wms'){
        if(wmsAuthRequired && !rhInventoryCookie){
            return <Redirect to={"/wmsauth/"+domain[2]} />
        }
    }

    let { route } = props;
    return (<Fragment>
        <WmsSectionAuthContext.Provider value={{status: (domain[1]=='wms' && wmsAuthRequired && rhInventoryCookie) ? rhSectionStatus : 'na'}}>
            <GullLayout route={route}></GullLayout>
        </WmsSectionAuthContext.Provider>
    </Fragment>)
}

export default Guard;